import React from 'react';
import { Box, Copy, Flex, Stack } from '@grubhubprod/gh-cookbook-react';
import { DownloadCsvTemplate } from 'src/components/enterprise/features/Employee/EmployeeListPage/components/AddEmployeesDialog/DownloadCsvTemplate';
import { DownloadEmployeesList } from 'src/components/enterprise/features/Employee/EmployeeListPage/components/AddEmployeesDialog/DownloadEmployeesList';

export function DownloadSection(): JSX.Element {
  return (
    <Stack y="lg">
      <Stack y="sm">
        <Copy variant="body">
          You can add employees to your account in two ways. You can upload a
          CSV of your employees’ information for the first time, or make updates
          to your existing CSV if you’ve already added one.
        </Copy>
      </Stack>

      <Flex>
        <Box flex="1" marginRight="12px">
          <DownloadCsvTemplate />
        </Box>
        <Box flex="1">
          <DownloadEmployeesList />
        </Box>
      </Flex>
    </Stack>
  );
}
